
import { useDispatch, useSelector } from "react-redux";
import TableComponent from "../../components/TableComponent";
import { ColumnHeaderType } from "../../utils/Types";
import { CLICK_ACTIONS, TYPE_OF_REQUEST_ID } from "../../utils/Constant";
import { BB_SYNC_FAILURE_HEADERS } from "./SyncFailureHelper";
import { useEffect, useState } from "react";
import { BBSyncFilterType } from "../../models/DashboardModels";
import { toast } from "react-toastify";
import { BBSyncFailureFilters } from "../../filters/BBSyncFailureFilters";
import Footer from "../../components/Footer";
import { getBBFailureTicketsApi, getBBFlrTcktExcelApi } from "../../api/grievancesApi";
import { formattedDate } from "../../utils/Util";


const SyncFailures = () => {
    const [searchId, setSearchId] = useState('');
    const [viewDetails, setViewDetails] = useState(false);
    const [selectedFilter, setSelectedFilter] = useState<BBSyncFilterType>(
        {
            dateFrom: undefined,
            dateTo: undefined,
            grievanceId: ''
        });
    const [count, setCount] = useState(0)
    const [totalCount, setTotalCount] = useState(0)
    const [limitSelected, setLimitSelected] = useState(25)
    const [limitStart, setLimitStart] = useState(0)
    const changePaginationLimit = (value: number) => {
        setLimitSelected(Number(value))
    };
    const prevPage = () => {
        if (limitStart >= limitSelected) {
            setLimitStart(limitStart - limitSelected)
        }
    };
    const nextPage = () => {
        if (totalCount > limitStart + limitSelected) {
            setLimitStart(limitStart + limitSelected);
        }
    };


    const dispatch: any = useDispatch();
    const storeBBFailureTicketsData = useSelector(
        (state: any) => state?.grievances?.storeBBFailureTicketsData || []
    );
    const countData = useSelector(
        (state: any) => state?.grievances?.storeBBFlrTcktCountData || {}
    );
    const excelData = useSelector(
        (state: any) => state?.grievances?.storeBBFlrTcktExcelData
    )
    const formatLocalDate = (date?: Date) => {
        if (!date) return undefined;

        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");

        return `${year}-${month}-${day}`;
    };
    const excelExport = () => {
        if (selectedFilter?.dateFrom && selectedFilter?.dateTo) {
            let sdate = selectedFilter.dateFrom
            let sepoch = sdate.getTime();
            let startdate = new Date(sepoch)

            let edate = selectedFilter.dateTo
            let eepoch = edate.getTime();
            let enddate = new Date(eepoch)

            const syear = startdate?.getFullYear();
            const smonth = (startdate.getMonth() + 1)?.toString()?.padStart(2, '0');
            const sday = (startdate?.getDate())?.toString()?.padStart(2, '0');
            const start = `${syear}-${smonth}-${sday}`;

            const eyear = enddate?.getFullYear();
            const emonth = (enddate.getMonth() + 1)?.toString()?.padStart(2, '0');
            const eday = (enddate?.getDate())?.toString()?.padStart(2, '0');
            const end = `${eyear}-${emonth}-${eday}`;

            dispatch(getBBFlrTcktExcelApi(start, end));
        }

        else {
            toast.warn('Please apply the required filters');
        }
    }

    useEffect(() => {
        const start = formatLocalDate(selectedFilter?.dateFrom);
        const end = formatLocalDate(selectedFilter?.dateTo);

        dispatch(getBBFailureTicketsApi(selectedFilter.grievanceId?.trim() || '', limitStart, limitSelected, start, end));
    }, [dispatch, selectedFilter, limitStart, limitSelected])

    useEffect(() => {
        if (storeBBFailureTicketsData?.count !== undefined) {
            setTotalCount(storeBBFailureTicketsData.count);
            setCount(storeBBFailureTicketsData.count);
        }
    }, [storeBBFailureTicketsData]);


    return (
        <div style={{ marginBottom: '66px', overflow: 'auto' }}>
            <p className="page-header">Bima Bharosa Sync Failures</p>
            <BBSyncFailureFilters onApplyFilters={setSelectedFilter} />
            <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
                <button className="create-grievance transition-colors duration-300"
                    onMouseEnter={(e) => (e.currentTarget.style.color = "black")}
                    onMouseLeave={(e) => (e.currentTarget.style.color = "white")}
                    onClick={() => { excelExport() }} >
                    Download Report
                </button>
            </div>
            <div className="table-container2">
                <TableComponent
                    data={storeBBFailureTicketsData?.data || []}
                    columnHeaders={BB_SYNC_FAILURE_HEADERS}
                />

                {(storeBBFailureTicketsData?.data?.length === 0) && (
                    <p className="nodata">Data Not Found</p>
                )}
            </div>

            <Footer
                count={count}
                totalCount={totalCount}
                changePaginationLimit={changePaginationLimit}
                nextPage={nextPage}
                prevPage={prevPage}
                limitSelected={limitSelected}
                limitStart={limitStart}
            />

        </div>
    );
};

export default SyncFailures;